import Action from 'lib/jsonApi/Action';
import { ActionParams, Pagination } from 'types/json-api-types';

export type FileParentData = {
  type: string,
  id: number,
  label: string,
  total_size?: number,
  files_count?: number,
  workflows_count?: number,
  is_archived?: boolean,
  direct?: boolean,
  path?: string[],
}

export default class ResourceMeta {
  actions?: Action[];

  pagination?: Pagination;

  parentDataType?: string;

  parentData?: FileParentData[]

  constructor(props: { actions?: ActionParams[] } = {}) {
    // Exclude getAction from rest to avoid overwriting our own arrow function
    // with a stale closure from a previous ResourceMeta instance.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { actions, getAction: _getAction, ...rest } = props as Record<string, unknown>;
    Object.assign(this, rest);
    if (actions) {
      this.actions = (actions as ActionParams[]).map((action: ActionParams) => new Action(action));
    }
  }

  getAction = (name: string) => {
    if (!this.actions) return undefined;
    return this.actions.find((a) => a.name === name);
  };
}
